var map = {
	"./about-us/view.js": "./template/blocks/about-us/view.js",
	"./brand-zone/view.js": "./template/blocks/brand-zone/view.js",
	"./collection-slider/view.js": "./template/blocks/collection-slider/view.js",
	"./common-slider/view.js": "./template/blocks/common-slider/view.js",
	"./hero-slider/view.js": "./template/blocks/hero-slider/view.js",
	"./latest-posts/view.js": "./template/blocks/latest-posts/view.js",
	"./our-shoowrooms/view.js": "./template/blocks/our-shoowrooms/view.js",
	"./product-category-slider/view.js": "./template/blocks/product-category-slider/view.js",
	"./product-slider-with-tabs/view.js": "./template/blocks/product-slider-with-tabs/view.js",
	"./products-slider-by-category/view.js": "./template/blocks/products-slider-by-category/view.js",
	"./sell-product/view.js": "./template/blocks/sell-product/view.js",
	"./wrapper-block/view.js": "./template/blocks/wrapper-block/view.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./template/blocks sync recursive view\\.js$";